import { Suspense, useCallback } from 'react';
import MenuOption from '~/constants/MenuOption';
import useClientSide from '~/hooks/useClientSide';
import Budget from './Budget';
import FilterDrawer from './FilterDrawer';
import useExpand from './useExpand';
import type WithClassName from './WithClassName';
import WithExpandOnOpen from './WithExpandOnOpen';

type OwnProps = WithClassName & WithExpandOnOpen;

export default function PaymentAndPrice({ className, expandOnOpen }: OwnProps) {
  const isClientSide = useClientSide();
  const expandSection = expandOnOpen === MenuOption.Price;
  const [show, setShow] = useExpand(expandSection);

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-payment-price"
      facetContent={2}
      facetName="Payment & Price"
      show={show}
      onToggle={useCallback(() => setShow(v => !v), [setShow])}
      expandOnOpen={expandSection}
    >
      <div className="px-24 py-32">
        {isClientSide ? (
          <Suspense fallback={null}>
            <Budget />
          </Suspense>
        ) : null}
      </div>
    </FilterDrawer>
  );
}
